import PropsTypes from "prop-types";
import Backdrop from "../Backdrop/Backdrop";
import "./Loader.css";

const Loader = (props) => {
  return (
    <>
      <div className="fixed z-50 top-0 left-0 right-0 bottom-0">
        <div
          className="relative"
          style={{ marginTop: "35vh", marginLeft: "calc(50% - 40px)" }}
        >
          <div className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="text-white -mt-5 relative">Please Wait </div>
        </div>
      </div>
      <Backdrop block={props.block} />
    </>
  );
};

Loader.propType = {
  block: PropsTypes.bool,
};

export default Loader;
